module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_maximize-fc517da02d6a64a68e5fea9a5de472f1.png";